import {Icon} from '@iconify/react';
import {Box, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React from 'react';

import {PlatformsConfig} from 'consts/platforms';
import TalentTierChip from '../TalentTierChip';

export type PlatformWithLabelSize = 'small' | 'medium';

interface Props {
  platform: 'instagram' | 'tiktok' | 'youtube' | 'twitch';
  label?: string;
  talentTier?: string;
  tooltip?: string;
  color?: 'primary' | 'secondary';
  size?: PlatformWithLabelSize;
  showTalentTier?: boolean;
}

const PlatformWithLabel: React.FC<Props> = ({
  platform,
  label,
  talentTier,
  color,
  size,
  showTalentTier,
}) => {
  const classes = useStyles({color, size});
  const platformConfig = PlatformsConfig[platform];
  return (
    <Box display="flex" alignItems="center">
      <Box className={classes.root}>
        <Icon
          icon={platformConfig.iconMono}
          color={color ?? 'black'}
          fontSize={size === 'small' ? 18 : 20}
        />
        {label && (
          <Typography className={classes.label} variant={size === 'small' ? 'caption' : 'body2'}>
            {label}
          </Typography>
        )}
        {showTalentTier && <TalentTierChip tier={talentTier ?? ''} size="small" />}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    color: (props: any) => (props.color === 'secondary' ? '#4E4E5A' : '#000000'),
    fontSize: (props: any) => (props.size === 'small' ? '14px' : '16px'),
  },
  label: {
    overflow: 'hidden',
    marginLeft: '0.3rem',
    marginRight: '0.5rem',
    textOverflow: 'ellipsis',
  },
});

export default PlatformWithLabel;
